import * as GC from '@grapecity/spread-sheets';
import { IStableBalanceCalibration } from '@models/stable-balance/stable-balance-calibration';
import { borders, FONT_NAME, FONT_SIZE } from '@shared/spread/spread-settings';

export const createHaircutInfo = (
  sheet: GC.Spread.Sheets.Worksheet,
  nonStablePercent: number[],
  latestCalibration: IStableBalanceCalibration,
  rowIndex: number,
  colOffSet: number
): number => {
  if (nonStablePercent.length > 0) {
    const colSpan = 2;
    const rowSpan = 2;
    const takenCols = 0;
    let takenRows = 0;

    const min = Math.min(...nonStablePercent, Infinity);
    const max = Math.max(...nonStablePercent, -Infinity);
    const total = nonStablePercent.reduce((a, b) => a + b, 0);
    const historicalHaircutMin = min;
    const historicalHaircutMax = max;
    const historicalHaircutMean = min < Infinity && max > -Infinity ? total / nonStablePercent.length : 0;
    const historicalHaircutTS = nonStablePercent[nonStablePercent.length - 1];

    // Title

    sheet
      .getCell(rowIndex, colOffSet)
      .text(`Historical Haircuts`)
      .font(`bold ${Math.round(Number(FONT_SIZE) * 1.3)}pt ${FONT_NAME}`)
      .vAlign(GC.Spread.Sheets.VerticalAlign.center)
      .hAlign(GC.Spread.Sheets.HorizontalAlign.center)
      .backColor('#2B495E')
      .foreColor('white');
    sheet.addSpan(rowIndex, colOffSet, rowSpan, colSpan);
    takenRows += rowSpan;

    // Mean header
    sheet
      .getCell(rowIndex + takenRows, colOffSet)
      .text('Mean:')
      .font(`bold ${FONT_SIZE}pt ${FONT_NAME}`);

    sheet.getCell(rowIndex + takenRows, colOffSet).borderLeft(borders.BLACK_MEDIUM);

    // Mean value
    sheet.getCell(rowIndex + takenRows, colOffSet + 1).value(historicalHaircutMean);
    sheet.getCell(rowIndex + takenRows, colOffSet + 1).borderRight(borders.BLACK_MEDIUM);
    sheet.getRange(rowIndex + takenRows, colOffSet, 1, 2).borderTop(borders.BLACK_MEDIUM);
    sheet.getCell(rowIndex + takenRows, colOffSet + 1).formatter('0 %_);[Red](0%)');

    rowIndex += 1;

    // Min header
    sheet
      .getCell(rowIndex + takenRows, colOffSet)
      .text('Min:')
      .font(`bold ${FONT_SIZE}pt ${FONT_NAME}`);

    sheet.getCell(rowIndex + takenRows, colOffSet).borderLeft(borders.BLACK_MEDIUM);

    // Min value
    sheet.getCell(rowIndex + takenRows, colOffSet + 1).value(historicalHaircutMin);
    sheet.getCell(rowIndex + takenRows, colOffSet + 1).formatter('0 %_);[Red](0%)');
    sheet.getCell(rowIndex + takenRows, colOffSet + 1).borderRight(borders.BLACK_MEDIUM);

    rowIndex += 1;

    // End Of TS header
    sheet
      .getCell(rowIndex + takenRows, colOffSet + takenCols)
      .text('End Of TS:')
      .font(`bold ${FONT_SIZE}pt ${FONT_NAME}`);
    sheet.getCell(rowIndex + takenRows, colOffSet).borderLeft(borders.BLACK_MEDIUM);

    // End Of TS value
    sheet.getCell(rowIndex + takenRows, colOffSet + 1).value(historicalHaircutTS);
    sheet.getCell(rowIndex + takenRows, colOffSet + 1).formatter('0 %_);[Red](0%)');
    sheet.getCell(rowIndex + takenRows, colOffSet + 1).borderRight(borders.BLACK_MEDIUM);
    rowIndex += 1;

    // Max header
    sheet
      .getCell(rowIndex + takenRows, colOffSet + takenCols)
      .text('Max:')
      .font(`bold ${FONT_SIZE}pt ${FONT_NAME}`);
    sheet.getCell(rowIndex + takenRows, colOffSet).borderLeft(borders.BLACK_MEDIUM);

    // Max value
    sheet.getCell(rowIndex + takenRows, colOffSet + takenCols + 1).value(historicalHaircutMax);
    sheet.getCell(rowIndex + takenRows, colOffSet + takenCols + 1).formatter('0 %_);[Red](0%)');
    sheet.getCell(rowIndex + takenRows, colOffSet + 1).borderRight(borders.BLACK_MEDIUM);
    sheet.getRange(rowIndex + takenRows, colOffSet, 1, 2).borderBottom(borders.BLACK_MEDIUM);

    rowIndex += takenRows;
  }

  return rowIndex;
};
